import { styled } from '@styles';

export const Preview = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 90%;
  height: 100%;
  background-color: ${(props) => props.theme.colors.light};
  img {
    height: 455px;
    mix-blend-mode: darken;
  }
`;
